import { useEffect } from 'react'

import { SubmitHandler, UseFormProps, UseFormReturn } from 'react-hook-form'

import { useFormWithSchema } from '@fortem-monorepo/react-spa'
import { Form } from '@fortem-monorepo/react-ui'

import { useRunScheduledTaskMutation } from '@/react-query/mutations/feeds'

import { type SchemaType, schema } from './RunManualTaskForm.schema'

export interface RunManualTaskFormProps extends Omit<UseFormProps<SchemaType>, 'resolver'> {
  children?: ((form: UseFormReturn<SchemaType>) => React.ReactNode) | React.ReactNode
  onSubmit?: SubmitHandler<SchemaType>
}

export const RunManualTaskForm: React.FC<RunManualTaskFormProps> = ({
  children,
  onSubmit,
  ...props
}) => {
  const form = useFormWithSchema({ mode: 'all', ...props }, schema)

  const runScheduledTaskMutation = useRunScheduledTaskMutation()

  const submit = form.handleSubmit(
    onSubmit ??
      (async (_data, _e) => {
        await runScheduledTaskMutation.mutateAsync({ task_id: _data.task_id })
        form.reset()
      }),
  )

  useEffect(() => {
    form.trigger()
  }, [])

  return (
    <Form {...form}>
      <form onSubmit={submit}>{typeof children === 'function' ? children(form) : children}</form>
    </Form>
  )
}
